import gql from 'graphql-tag';
import { LocationFragment } from 'Queries/Location';

export const PobNodesQuery = gql`
	query GetRigPobNodes($customerID: ID!, $rigID: ID!) {
		GetRigPobNodes(customerID: $customerID, rigID: $rigID) {
			_id
			checkInType
			firstName
			lastName
			checkedIn
			createdTs
			personID {
				_id
			}
			destinationID {
				...LocationFragment
			}
			currentCarrierID {
				... on FlightNode {
					_id
					desig
					legsArray {
						destinationID
					}
					classType
				}
				... on BoatNode {
					_id
					desig
					classType
				}
			}
			lastKnownController {
				_id
				name
				getRig {
					_id
					bedQuartersIds
				}
			}
			currentJobTitle
		}
	}
	${LocationFragment}
`;

export const SetPobNodeMutation = gql`
	mutation QuartermasterSetPobNodeCheckInType($payload: PobNodeInput!) {
		setPobNode(payload: $payload) {
			_id
			lastName
			firstName
			checkInType
		}
	}
`;

export const AddPobMutation = gql`
	mutation QuartermasterAddPob($payload: PersonToNewPobNodePayload!) {
		PersonToNewPobNode(payload: $payload) {
			_id
			checkInType
			firstName
			lastName
			checkedIn
			createdTs
			personID {
				_id
			}
			currentCarrierID {
				... on FlightNode {
					_id
					desig
					legsArray {
						destinationID
					}
					classType
				}
				... on BoatNode {
					_id
					desig
					classType
				}
			}
			lastKnownController {
				_id
				name
				getRig {
					_id
					bedQuartersIds
				}
			}
		}
	}
`;

export const SetPobCheckInTypeMutation = gql`
	mutation SetPobCheckInType($payload: SetPobCheckInTypeInput!) {
		setPobCheckInType(payload: $payload)
	}
`;
